import React, { useState, useEffect } from "react";
import avatar from "../../assets/images/png/avatar.png";
import logo from "../../assets/images/png/luaa_logo.png";
import { NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toggleNav } from "../../actions/component.action";
import { getProfile } from "../../actions/profile.action";
import { Loading } from "../../utils/helpers/constants";
import { TopNavContainer } from "./style";

export default function HeaderUser(props) {
  const dispatch = useDispatch();
  const [photoUrl, setPhotoUrl] = useState("");
  const toggleNavBar = () => dispatch(toggleNav(true));

  const [navbarOpen, setNavbarOpen] = React.useState(false);

  const profile = useSelector(({ profileReducer }) => profileReducer);

  useEffect(async () => {
    if (profile.userProfileLoading !== Loading.SUCCESS)
      await dispatch(getProfile());
    setPhotoUrl(
      profile.profileImage !== null || profile.profileImage !== ""
        ? profile.profileImage
        : avatar
    );
  }, [profile.profileImage]);

  return (
    <TopNavContainer {...props}>
      <nav class="bg-white shadow-m px-2 sm:px-4 py-2 rounded dark:bg-gray-900 sticky top-0">
        <div class="container flex flex-wrap justify-between items-center mx-auto">
          <a href="/" class="flex items-center">
            <img src={logo} class="mr-3 h-6 sm:h-9" alt="Compass Logo" />
            <span class="self-center text-xl font-semibold whitespace-nowrap dark:text-white compass_color">
              Compass
            </span>
          </a>
          <button
            data-collapse-toggle="navbar-default"
            type="button"
            class="inline-flex items-center p-2 ml-3 text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
            aria-controls="navbar-default"
            aria-expanded="false"
            onClick={() => setNavbarOpen(!navbarOpen)}
          >
            <span class="sr-only">Open main menu</span>
            <svg
              class="w-6 h-6"
              aria-hidden="true"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
              data-darkreader-inline-fill=""
            >
              <path
                fillRule="evenodd"
                d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                clipRule="evenodd"
              ></path>
            </svg>
          </button>
          <div
            className={`${
              navbarOpen ? null : "hidden"
            } w-full md:block md:w-auto`}
            id="navbar-default"
          >
            <ul class="flex flex-col p-4 mt-4 bg-gray-50 rounded-lg border border-gray-100 md:flex-row md:space-x-8 md:mt-0 md:text-sm md:font-medium md:border-0 md:bg-white dark:bg-gray-800 md:dark:bg-gray-900 dark:border-gray-700">
              <li>
                <NavLink exact to="/">
                  <div className="flex">
                    &nbsp; <div className="compass_color font-bold">Home</div>
                  </div>
                </NavLink>
              </li>
              <li>
                <NavLink exact to="/dashboard/user/secretariat">
                  <div className="flex">
                    &nbsp;
                    <div className="compass_color font-bold">Secretariat</div>
                  </div>
                </NavLink>
              </li>
              <li>
                <NavLink exact to="/dashboard/user/communities">
                  <div className="flex">
                    &nbsp;
                    <div className="compass_color font-bold">Community</div>
                  </div>
                </NavLink>
              </li>
              <li>
                <NavLink exact to="/dashboard/user/events">
                  <div className="flex">
                    &nbsp;
                    <div className="compass_color font-bold">Event</div>
                  </div>
                </NavLink>
              </li>
              <li>
                <NavLink exact to="/dashboard/user/terms&condition">
                  <div className="flex">
                    &nbsp;
                    <div className="compass_color font-bold">Terms</div>
                  </div>
                </NavLink>
              </li>
              <li>
                <NavLink exact to="/dashboard/user/privacy-policy">
                  <div className="flex">
                    &nbsp;
                    <div className="compass_color font-bold">Privacy</div>
                  </div>
                </NavLink>
              </li>

              <li>
                <NavLink exact to="/dashboard/user/messages">
                  <div className="flex">
                    &nbsp;
                    <div className="compass_color font-bold">Messages</div>
                  </div>
                </NavLink>
              </li>

              <li>
                <NavLink exact to="/dashboard/profile">
                  <div className="flex">
                    &nbsp;
                    <div className="compass_color font-bold">Profile</div>
                  </div>
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </TopNavContainer>
  );
}
